import { ISideNavItem, ISideNavLeafOption } from "./side-nav.types";

export function hasChildren(item: ISideNavItem): boolean {
  return Boolean(item.children && item.children.length > 0);
}

export function hasItemIcons(items: readonly ISideNavItem[]): boolean {
  return items.some(
    (item) => Boolean(item.icon) || hasItemIcons(item.children ?? []),
  );
}

export function getItemPath(
  items: readonly ISideNavItem[],
  targetId: string,
): ISideNavItem[] {
  for (const item of items) {
    if (item.id === targetId) return [item];
    const childPath = getItemPath(item.children ?? [], targetId);
    if (childPath.length) return [item, ...childPath];
  }
  return [];
}

export function getLeafOptions(
  items: readonly ISideNavItem[],
  ancestors: readonly ISideNavItem[] = [],
): ISideNavLeafOption[] {
  const result: ISideNavLeafOption[] = [];

  for (const item of items) {
    const nextAncestors = [...ancestors, item];
    if (hasChildren(item)) {
      result.push(...getLeafOptions(item.children ?? [], nextAncestors));
    } else {
      result.push({
        item,
        ancestors: [...ancestors],
        groupLabel: ancestors[0]?.label ?? item.label,
      });
    }
  }

  return result;
}

export function filterItems(
  items: readonly ISideNavItem[],
  query: string,
): ISideNavItem[] {
  return items.flatMap((item) => {
    const selfMatches = item.label.toLocaleLowerCase().includes(query);
    const childMatches = filterItems(item.children ?? [], query);
    if (selfMatches) {
      return [{ ...item }];
    }
    if (childMatches.length) {
      return [{ ...item, children: childMatches }];
    }
    return [];
  });
}

export function getItemById(
  items: readonly ISideNavItem[],
  id: string,
): ISideNavItem | null {
  for (const item of items) {
    if (item.id === id) return item;
    const nested = getItemById(item.children ?? [], id);
    if (nested) return nested;
  }
  return null;
}

export function getItemPathIds(
  items: readonly ISideNavItem[],
  targetId: string,
): string[] {
  for (const item of items) {
    if (item.id === targetId) return [item.id];
    const childPath = getItemPathIds(item.children ?? [], targetId);
    if (childPath.length) return [item.id, ...childPath];
  }
  return [];
}
